"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CashTrialRequest = void 0;
var CashTrialRequest = /** @class */ (function () {
    function CashTrialRequest() {
        this.applyAmount = '';
        this.applyTerm = '';
    }
    return CashTrialRequest;
}());
exports.CashTrialRequest = CashTrialRequest;
;
//# sourceMappingURL=cashTrial.request.js.map